import React from 'react';
import {useSelector} from 'react-redux';

import {Skeleton} from 'src/components/skeleton';
import {useAdminAccessRight} from 'src/hooks/access-rights';
import {TabContent} from 'src/modules/profile/account/tabs/admin-account-api-v2/components/tab-content';
import {usePricingSubscriptions} from 'src/modules/profile/account/tabs/admin-account-api-v2/views/controllers/contracts/hooks';
import {setupDataSelector} from 'src/modules/profile/account/tabs/admin-account-api-v2/views/controllers/setup/services/selectors';
import {PricingModel} from 'src/openapi/admin/models/PricingModel';

import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';
import Typography from '@pb/kit-component-typography';


import {ContractLimitsList} from './controllers/contract-limits';
import {OverageController} from './controllers/overage';

import {apiV2Limits} from './limits.module.styl';

import type {TabProps} from '../../typedef';


export const LimitsTab = ({accountId}: TabProps) => {
    usePricingSubscriptions();
    const setupData = useSelector(setupDataSelector);

    const {canEditApiV2} = useAdminAccessRight();
    const canEdit = canEditApiV2(accountId);

    return (
        <Skeleton shown={!setupData} view={<Loading fast={true}/>}>
            <TabContent>
                <Group className={apiV2Limits} direction="v" gap="l" alignItems="start">
                    {setupData?.crmIntegration ? (
                        <Group direction="v" alignItems="start">
                            <Typography
                                fontWeight="semi-bold"
                                variant="heading-level-3">
                                Integration Limits
                            </Typography>
                            <ContractLimitsList
                                accountId={accountId}
                                pricingModel={PricingModel.INTEGRATION}
                                disabled={!canEdit}
                            />
                        </Group>
                    ) : (
                        <>
                            <Group direction="v" alignItems="start">
                                <Typography
                                    fontWeight="semi-bold"
                                    variant="heading-level-3">
                                    Subscription Limits
                                </Typography>
                                <OverageController accountId={accountId} disabled={!canEdit}/>
                                <ContractLimitsList
                                    accountId={accountId}
                                    pricingModel={PricingModel.SUBSCRIPTION}
                                    disabled={!canEdit}
                                />
                            </Group>

                            <Group direction="v" alignItems="start">
                                <Typography
                                    fontWeight="semi-bold"
                                    variant="heading-level-3">
                                    Pay-per-Call Limits
                                </Typography>
                                <ContractLimitsList
                                    accountId={accountId}
                                    pricingModel={PricingModel.PAY_PER_CALL}
                                    disabled={!canEdit}
                                />
                            </Group>
                        </>
                    ) }
                </Group>
            </TabContent>
        </Skeleton>
    );
};
